module.exports = __webpack_public_path__ + "static/img/unMute_camera.b951f02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/unMute_camera.png
// module id = IH94
// module chunks = 24